<template>
  <div class="app_detail_container">
    <PageTitle
      :title="title"
      :showFileBtn="true"
      backPath="AppReportApprove"
      :menuArgs="menuArgs"
      @clickFileBtn="clickFileBtn"
    />
    <div class="app_menu_main">
      <PageDetailDivider ref="PageDetailDividerRef" title="主表信息" />
      <div class="app_menu_main_form">
        <el-form :rules="rules" :model="form">
          <el-form-item label="报告编号" prop="num">
            <el-input placeholder="关联获取" readonly v-model="form.num" />
          </el-form-item>
          <el-form-item label="委托单位" prop="client">
            <el-input placeholder="关联获取" readonly v-model="form.client" />
          </el-form-item>
          <el-form-item label="申请人" prop="users_name">
            <el-input placeholder="关联获取" readonly v-model="form.users_name" />
          </el-form-item>
          <el-form-item label="申请日期" prop="apply_date">
            <el-input placeholder="关联获取" v-date readonly v-model="form.apply_date" />
          </el-form-item>
          <el-form-item label="是否盖章" prop="is_stamped">
            <el-input placeholder="关联获取" readonly v-model="form.is_stamped" />
          </el-form-item>
          <el-form-item label="是否邮寄" prop="is_mailed">
            <el-input placeholder="关联获取" readonly v-model="form.is_mailed" />
          </el-form-item>
          <el-form-item label="是否到款" prop="is_payment_arrived">
            <el-input placeholder="关联获取" readonly v-model="form.is_payment_arrived" />
          </el-form-item>
          <el-form-item label="说明" prop="memo">
            <el-input type="textarea" :rows="2" placeholder="关联获取" readonly v-model="form.memo" />
          </el-form-item>
          <el-form-item label="财务审核意见" prop="financial_annotations">
            <el-input type="textarea" :rows="2" readonly v-model="form.financial_annotations" />
          </el-form-item>
          <el-form-item label="领导审批意见" prop="approve_opinions">
            <el-input type="textarea" :rows="5" readonly v-model="form.approve_opinions" />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <PageDetailBtns ref="PageDetailBtnsRef" menuPath="ReportApprove" :parentData="this" @handleClick="handleClickBtn" />
    <!-- 附件 -->
    <PageDetailFile ref="PageDetailFileRef" :ID="id" vuePath="ReportApprove" />

    <FastInputVue ref="FastInputVueRef" :isMobile="true" @sureBack="sureBackApprovalOpinions" />

    <!-- 财务审核 -->
    <ApproveOption ref="ApproveOptionRef" @sureBack="sureBackApprovalOpinions" />

    <!-- 确认dialog -->
    <ConfirmModal ref="ConfirmModalRef" @confirm="sureConfirm" />
  </div>
</template>
<script>
import PageTitle from '@/components/app/PageHeader.vue'
import PageDetailBtns from '@/components/app/PageDetailBtns.vue'
import PageDetailDivider from '@/components/app/PageDetailDivider.vue'
import PageDetailFile from '@/components/app/PageDetailFile.vue'
import FastInputVue from '@/components/Modal/FastInput/FastInput.vue'
import ApproveOption from '@/components/Modal/FastInput/ApproveOption.vue'
import ConfirmModal from '@/components/app/ConfirmModal.vue'

export default {
  components: {
    PageTitle,
    PageDetailBtns,
    PageDetailDivider,
    PageDetailFile,
    FastInputVue,
    ConfirmModal,
    ApproveOption
  },
  data() {
    return {
      id: -1,
      title: '报告审批明细',
      formVisible: false,
      // 表单
      form: {
        id: 0,
        creator_id: 0,
        creator: '',
        createTime: '',
        num: '',
        client: '',
        users_name: '',
        apply_date: '',
        memo: '',
        document_status: 0,
        financial_annotations: '',
        approve_opinions: '',
        last_modify_time: ''
      },
      rules: {
        num: [
          { required: true, message: '请输入报告编号', trigger: 'change' },
          {
            min: 0,
            max: 32,
            message: '长度在 0 到 32 个字符',
            trigger: 'change'
          }
        ],
        client: [
          { required: true, message: '请输入委托单位', trigger: 'change' },
          {
            min: 0,
            max: 256,
            message: '长度在 0 到 256 个字符',
            trigger: 'change'
          }
        ],
        users_name: [],
        apply_date: [{ required: true, message: '请输入申请日期', trigger: 'change' }],
        memo: [
          {
            min: 0,
            max: 512,
            message: '长度在 0 到 512 个字符',
            trigger: 'change'
          }
        ],
        document_status: [],
        approve_opinions: [],
        last_modify_time: []
      },
      // 下拉框
      ComBoxItems: {
        company: []
      },
      // 展示金额
      showMoney: true,
      menuArgs: ''
    }
  },
  mounted() {
    this.id = this.$route.query.id

    this.BindText()

    this.menuArgs = this.$route.query.menuArgs
  },
  methods: {
    // 确认
    async sureConfirm(code) {
      if (code === 'refuse') {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      } else if (code === 'unReview') {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      }
    },
    // 输入完意见
    async sureBackApprovalOpinions(options, type = '') {
      const flag = await this.sureReview(false, options)

      if (flag) {
        this.$message.success('操作成功!')

        this.$emit('updateData')
        this.BindText()

        if (type === 'fa') {
          this.$refs.ApproveOptionRef.closeModal()
        } else {
          this.$refs.FastInputVueRef.closeModal()
        }
      }
    },
    // 领导/总经理审批
    refuse() {
      this.$confirm('是否确认拒绝?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 领导/总经理审批
    leaderReview() {
      this.$confirm('是否确认审批通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 取消审核
    unReview() {
      this.$confirm('是否确认取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 调用审批接口
    async sureReview(flag = false, approve_opinions) {
      const approve_obj = typeof approve_opinions === 'string' ? { approve_opinions } : approve_opinions

      const { data: res } = await this.$http.put('/Finance/Report_approve/audit', [
        {
          id: this.id,
          manager_review: flag,
          ...approve_obj
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false) {
      const { data: res } = await this.$http.put('/Finance/Report_approve/unaudit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      return true
    },
    // 调用拒绝接口
    async sureObsolete() {
      const { data: res } = await this.$http.put('/Finance/Report_approve/obsolete', [
        {
          id: this.id,
          manager_review: false
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 点击底部按钮
    handleClickBtn(code) {
      switch (code) {
        case 'save':
          this.save()
          break
        case 'del':
          this.del()
          break
        case 'unReview':
          // this.unReview()
          this.$refs.ConfirmModalRef.openDialog('unReview')
          break
        case 'faReview':
        case 'financialReview':
          this.$refs.ApproveOptionRef.openModal()
          break
        case 'managerReview':
        case 'leaderReview':
          // this.leaderReview()
          this.$refs.FastInputVueRef.openModal()
          break
        case 'refuse':
          // this.refuse()
          this.$refs.ConfirmModalRef.openDialog('refuse')
          break
        case 'close':
          this.formVisible = false
          break
      }
    },
    // 绑定数据
    async BindText() {
      const that = this
      const { data: res } = await that.$http.get('/Finance/Report_approve', {
        params: {
          id: that.id
        }
      })
      if (res.isSuccess) {
        that.form = res.data
      }
    },
    // 点击附件按钮
    clickFileBtn() {
      this.$refs.PageDetailFileRef.openDialog()
    },
    showModal() {},
    // 大写金额转换
    convertCurrency(amount) {
      if (amount == null || amount == '') {
        return ''
      }
      return this.amountLtoU(amount)
    },
    // 选择人员
    handleSelect() {},
    // 主表选择框值改变为空时
    clearFormToNull(type) {
      switch (type) {
        case '':
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
@headerHeight: 50px;

.app_detail_container {
  width: 100vw;
  height: 100vh;

  .app_menu_main {
    height: calc(100% - @headerHeight);
    width: 100%;
    // background-color: #fafafa;

    overflow: auto;

    box-sizing: border-box;
    // padding: 0 20px;
    // padding-top: 10px;
    // padding-bottom: 20px;

    /deep/ .el-form-item__label {
      padding: 0 !important;
      font-size: 20px !important;
      font-weight: 500;
      color: #a78897;
    }
    /deep/ .el-input__inner {
      border: 0 !important;
      border-bottom: 1px solid #d1d1d1 !important;
      border-radius: 0;
      padding-left: 0 !important;
      transition: all 0.3s;
      // background-color: #fafafa;
      font-size: 18px !important;
    }

    /deep/ .el-textarea__inner {
      font-size: 18px !important;
    }

    // /deep/ .el-input__inner:hover {
    //   padding-left: 10px !important;
    //   transition: all 0.3s;
    // }
    /deep/ .el-input__inner:focus {
      padding-left: 10px !important;
      transition: all 0.3s;
    }

    .app_menu_main_form {
      box-sizing: border-box;
      padding: 0 20px 20px 20px;
    }
  }
}
.file-list-container {
  // box-sizing: border-box;
  padding: 10px;

  height: 30px;
}
</style>
